import { useCallback, useState } from 'react'
import messsages from '../services/messages'
import { useDispatch } from 'react-redux'
import {
  setSummary,
  setSummaries,
  getSummaries,
  createSummary,
  resetLoading,
} from '../redux/summaries/actions'

export const useGenerateSummary = ({
  messageId = null,
  conversationId,
  onSuccess,
  onError,
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const dispatch = useDispatch()

  const generateSummary = useCallback(async () => {
    setIsLoading(true)
    dispatch(createSummary())
    await messsages({
      method: 'post',
      url: `/tech4h-messages/conversation/${conversationId}/summary`,
      data: {
        messageId,
      },
    })
      .then((response) => {
        onSuccess(response.data)
        dispatch(setSummary())
        fetchAllSummaries()
      })
      .catch((error) => onError(error))
      .finally(() => {
        setIsLoading(false)
        dispatch(resetLoading())
      })
  }, [conversationId, messageId, onSuccess, onError])

  const fetchAllSummaries = useCallback(async () => {
    dispatch(getSummaries())
    await messsages({
      method: 'get',
      url: `/tech4h-messages/conversation/${conversationId}/summaries`,
    })
      .then((response) => {
        dispatch(setSummaries(response?.data?.summaryResult, conversationId))
      })
      .catch((error) => onError(error))
      .finally(() => dispatch(resetLoading()))
  }, [conversationId, onError])

  return {
    isLoading,
    generateSummary,
    fetchAllSummaries,
  }
}
